import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';

export const productRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/products',
  component: lazyRouteComponent(() => import('@/pages/products/product-page')),
});
